import { useContext } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { useTranslate } from '@/hooks/useTranslate';
import { shouldShowZipCodeFieldForTaxCalculation } from '@/utils/tax';
import { getSubscriptionDisclaimerData } from './utils';

/**
 * ROSCA/FTC legal disclaimer (ACDEV-26078, ported from v2): must be visible
 * before the player confirms a subscription purchase, for EVERY payment
 * method. Rendered ONCE by {@link Payment}, below the payment body, so it
 * covers the card CTA and the wallet buttons alike; returns null off the
 * subscription route, where there is no plan to disclose.
 */
export const SubscriptionDisclaimer = () => {
  const { subscription, pricing, customer } = useContext(CheckoutContext);
  const { t } = useTranslate();

  // US/CA quote pre-tax ("excluded taxes") — the same jurisdiction gate that
  // drives the ZIP-for-tax field.
  const isTaxExcludedCountry = customer ? shouldShowZipCodeFieldForTaxCalculation(customer) : false;
  const disclaimerData = getSubscriptionDisclaimerData({ plan: subscription?.plan, pricing }, isTaxExcludedCountry);

  if (!disclaimerData) return null;

  return (
    <div data-testid="subscription-renewal-disclaimer" className="w-full text-xs text-left text-[#323241]">
      {t('subscriptionRenewalDisclaimer', {
        period: t(disclaimerData.renewalPeriodKey),
        amount: disclaimerData.amount,
        taxes: t(disclaimerData.taxesKey),
      })}
    </div>
  );
};
